<template>
    <div>
        <ui-modal ref="saveDataViewModal" title="Save View" @hide="reset" size="small" dismiss-on="close-button esc">
            <div class="container-fluid" style="padding: 0; margin-top: 1rem;">
                <div class="row">
                    <div class="col-12">
                        <ui-textbox label="Name" v-model="name"></ui-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <ui-switch label="Private" v-model="isPrivate"></ui-switch>
                    </div>
                </div>
            </div>

            <div slot="footer" style="width: 100%; text-align: right;">
                <ui-progress-circular v-show="isLoading" style="float:left;"></ui-progress-circular>
                <button :disabled="isLoading" class="btn btn-primary" @click="save">Save</button>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex'

    export default {
        data() {
            return {
                name: '',
                savedViewId: null,
                isPrivate: true,
                isLoading: false,
            }
        },
        computed: {
            ...mapState({
                savedViews: state => state.dataView.savedViews
            })
        },
        methods: {
            ...mapActions({
                saveView: 'dataView/save',
            }),
            reset() {
                this.name = '';
                this.savedViewId = null;
                this.isPrivate = true;
                this.isLoading = false;
            },
            open(savedDataViewId = null) {
                this.reset();

                if (savedDataViewId) {
                    let view = this.savedViews.find(item => {
                        return item.id === parseInt(savedDataViewId)
                    })

                    if (view) {
                        this.name = view.name
                        this.isPrivate = view.is_private
                        this.savedViewId = view.id
                    }
                }

                this.$refs['saveDataViewModal'].open();
            },
            save() {
                this.isLoading = true;

                let attr = { 
                    id: this.savedViewId,
                    name: this.name, 
                    is_private: this.isPrivate 
                };

                this.saveView(attr).then(response => {
                    this.isLoading = false;

                    this.$refs['saveDataViewModal'].close()
                }, error => {
                    this.isLoading = false;
                });
            }
        }
    }
</script>